import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import Picture from "./Picture";
import Button from "@material-ui/core/Button";

export default class Pictures extends PureComponent {
  static propTypes = {
    type: PropTypes.string,
    pictures: PropTypes.array,
    removability: PropTypes.bool,
    onRequestCloseModal: PropTypes.func
  };
  state = {
    end: 40
  };
  showMore = () => {
    const step = 40;
    this.setState({
      end: this.state.end + step
    });
  };
  render() {
    const {pictures, onRequestCloseModal, removability, type} = this.props;
    const {end} = this.state;
    return (
      <React.Fragment>
        <div className="pictures">
          {pictures.length ? (
            pictures.slice(0, end).map((picture) => {
              return (
                <div key={picture.id} className="pictures__item">
                  <Picture
                    type={type}
                    picture={picture}
                    removability={removability}
                    onRequestCloseModal={onRequestCloseModal}
                  />
                </div>
              );
            })
          ) : (
            <span style={{padding: `20px 0`}}>Нет изображений</span>
          )}
        </div>
        <div className="pictures__more">
          {pictures.length && end <= pictures.length ? (
            <Button variant="outlined" onClick={this.showMore}>
              Показать ещё
            </Button>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}
